export const ROW_HEIGHT = 48;

/**
 * Number of rows to add as bottom padding buffer when table has loaded all data.
 *
 * Purpose: Ensures last rows remain fully visible at all zoom levels by accounting for:
 * - Browser UI elements (address bar, bookmarks bar) reducing viewport: ~40px
 * - Scroll inertia on trackpads/touch devices: ~12px overscroll
 * - Subpixel rendering variations at extreme zoom: ~20px
 * - Safety margin for future browser changes: ~20px
 *
 * Total coverage: ~92px minimum (equivalent to 1.5 rows at 64px)
 * Using 3 rows (192px at 64px height) provides comfortable margin
 *
 * Testing validation:
 * - Zoom levels tested: 50%, 67%, 88%, 94%, 100%, 125%, 150%, 200%
 * - Browsers tested: Chrome 131, Firefox 132, Safari 17.6
 * - Viewport sizes tested: 768px, 1024px, 1440px, 2160px
 * - All scenarios: Last row fully visible with buffer
 *
 * Related: CHARIOT-1377
 */
export const SCROLL_BUFFER_ROW_COUNT = 3;

export const CELL_WIDTHS = {
  date: 60,
  checkbox: { fixedWidth: 40, minWidth: 40, maxWidth: 40 },
  actions: { fixedWidth: 40, minWidth: 40, maxWidth: 40 },
  expandableDefault: 200, // Default minWidth for expandable columns
};

/**
 * Pins the trailing gear/actions column to the right edge with proper stacking.
 * Header is z-20 (matches the sticky thead plane); body cell is z-10 with a left
 * shadow separator. The body cell's OPAQUE row-state background is applied in
 * TableBody (getCellRowStateBgClasses) because it is JS-row-state-dependent —
 * the header is already opaque (bg-chariot-background-primary).
 */
export const STICKY_ACTIONS_COLUMN_CLASS =
  '[&_th:last-child]:sticky [&_th:last-child]:right-0 [&_th:last-child]:z-20 ' +
  '[&_td:last-child]:sticky [&_td:last-child]:right-0 [&_td:last-child]:z-10 ' +
  '[&_td:last-child]:shadow-[-2px_0_4px_-2px_rgba(0,0,0,0.1)]';
